import { EpaPga } from './types';
import { PgaValidationArgs } from '../types';
import { CompoundPgaValidator } from 'libs/entryValidation/pga/compoundPgaValidator';

export class EpaValidator extends CompoundPgaValidator<EpaPga> {
  isApplicable({ pga }: PgaValidationArgs<EpaPga>): boolean {
    return pga.programCode === 'EPA';
  }
}
